import { render, staticRenderFns } from "./FixedProperty.vue?vue&type=template&id=5c89234c&"
import script from "./FixedProperty.vue?vue&type=script&lang=js&"
export * from "./FixedProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports